import React from 'react';

export const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div  className='container' style={styles.container}>
        <div style={styles.section}>
          <h3>About Us</h3>
          <p>We provide the best services to help you grow your business.</p>
        </div>
        <div style={styles.section}>
          <h3>Quick Links</h3>
          <ul style={styles.list}>
            <li><a href="/">Home</a></li>
            <li><a href="#aboutus">About Us</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
        <div style={styles.section}>
          <h3>Follow Us</h3>
          <div style={styles.socialIcons}>
            <a href="https://facebook.com">Facebook</a> |
            <a href="https://twitter.com">Twitter</a> |
            <a href="https://instagram.com">Instagram</a>
          </div>
        </div>
      </div>
      <div style={styles.bottomBar}>
        <p>&copy; {new Date().getFullYear()} Rodxexforden. All rights reserved.</p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#ffffff17',
    backdropFilter: 'blur(5px)',
    color: '#fff',
    padding: '10px 0',
    textAlign: 'center',
    width: '100%'
  },
  container: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  section: {
    margin: '10px',
    maxWidth: '300px',
  },
  list: {
    listStyle: 'none',
    padding: 0,
  },
  socialIcons: {
    marginTop: '10px',
  },
  bottomBar: {
    marginTop: '20px',
    borderTop: '1px solid #555',
    paddingTop: '10px',
  },
};


